import { API } from "aws-amplify";
import { Pad, Route } from "../aircraft/types";

export const getRoutes = async (): Promise<Route[]> => {
  try {
    const res = await API.get("api", "/addressfind/list", {});
    return res;
  } catch (err) {
    throw err;
  }
};
/*
Admin API
geofence list
*/
export const geofenceList = () => {
  return API.get("api", `/geofence/list`, {});
};

export const listLandingPads = async (): Promise<Pad[]> => {
  const res = await API.get("api", "/addressfind/listLandingPads", {
    responseType: "json",
  });

  return res;
};

export const getLandingZoneList = async (cellId: number): Promise<any> => {
  try {
    const res = await API.get("core", `/landingzone/activeInCell/${cellId}`, {
      responseType: "json",
    });
    return res;
  } catch (err) {
    throw err;
  }
};
